// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useEffect } from 'react'
import * as pages from '../pages'
import { RoutedApp } from '../lib'
import logo from '../logo.svg'
import { Route } from 'react-router'
import useScreenSize from '../lib/webid/useScreenSize'


const SuppliersApp: React.FC = () => {
  const gettext: (value: string) => string = (value) => value
  const isFullScreen = useScreenSize()

  useEffect(() => {
    document.title = "Suppliers - Molano Cloud"
  }, [])

  return (
    <RoutedApp
      anonymous
      isUnsupportedDevice={() => {return !isFullScreen}}
      logo={logo}
      name={gettext("Supplier Service Desk")}
      ready={true}
    >
      <Route path="/orders/:id" component={pages.RegisterTrackingCodePage} />
    </RoutedApp>
)}

export default SuppliersApp
